(function () {
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var video = entry.target;
      if (entry.isIntersecting) {
        if (!video.dataset.lazyLoaded) {
          // 处理 <source data-src> 写法
          video.querySelectorAll('source[data-src]').forEach(function (source) {
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
          });
          // 处理 <video data-src> 写法
          if (video.dataset.src && !video.src) {
            video.src = video.dataset.src;
            video.removeAttribute('data-src');
          }
          video.dataset.lazyLoaded = 'true';
          video.load();
        }
        video.play().catch(function () {});
      } else {
        video.pause();
      }
    });
  }, { rootMargin: '0px', threshold: 0.1 });

  function initLazyVideos() {
    document.querySelectorAll('video[data-lazy]').forEach(function (video) {
      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLazyVideos);
  } else {
    initLazyVideos();
  }
})();
